import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d="M10.485 6.457l-.942-.942-6.21 6.209v.943h.943l6.21-6.21zm.943-.942l.943-.943-.943-.943-.943.943.943.943zM4.828 14H2v-2.829l8.957-8.956a.667.667 0 01.942 0L13.785 4.1a.667.667 0 010 .942L4.83 14h-.001z"
      ></path>
    </svg>
  )
}

export default Icon
